// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"47637be8","453":"a642ee76","479":"1d3f9a4b","503":"0f7aa55a"}[chunkId] + ".chunk.js";
};